<template>
    <div>
        <table class="table table-borderless">

            <thead>
                <tr>
                    <th>Name</th>
                    <th>Person name</th>
                    <th>Phone</th>
                    <th>Email</th>
                    <th>Actions</th>
                </tr>
            </thead>

            <tbody>
                <tr v-for="(item, key) in dataItems" :key="key">

                    <td>
                         <div class="form-group">
                              <input class="form-control border border-dark" placeholder="name" type="text" v-model.lazy.trim="item.name" required />
                         </div>
                    </td>

                    <td>
                        <div class="form-group">
                            <input
                                class="form-control border border-dark"
                                placeholder="contact person"
                                type="text"
                                v-model.lazy.trim="item.contact_person"
                                required />
                         </div>
                    </td>

                    <td>
                        <div class="form-group">
                            <input class="form-control border border-dark" placeholder="xxx-xxx-xxx" type="text" v-model.lazy.trim="item.phone" />
                         </div>
                    </td>

                    <td>
                        <div class="form-group">
                            <input class="form-control border border-dark" placeholder="email" type="email" v-model.lazy.trim="item.email" />
                        </div>
                    </td>

                    <td>
                        <update-button :user-permissions="userPermissions" @click="onUpdate(item)"> Save </update-button>
                        <delete-button :user-permissions="userPermissions" @click="onDelete(item)"> Delete </delete-button>
                    </td>

                </tr>
            </tbody>
        </table>

        <div class="alert alert-info">
            For phone number you can use <code><strong>+</strong></code> or <code><strong>00</strong></code> as prefix before numbers,
            following with 9 numbers that are separated by either <code><strong>-</strong></code>, <code><strong>'&nbsp;'</strong></code> (space character) or nothing between numbers.
        </div>

        <add-button :user-permissions="userPermissions" @click="onAdd({'contactable_type' : 'App/Organization'})"> New Contact </add-button>
        <status-feedback :successFeedback="successFeedback" :failFeedback="failFeedback" :errors="errors" ></status-feedback>

   </div>

</template>

<script>

import AjaxListMixin from '../mixins/AjaxListMixin';
import PermissionButtons from '../mixins/PermissionButtonsMixin';

export default{

    mixins: [AjaxListMixin, PermissionButtons],

    props: {

        items: {
            type : Array,
            default : () => {return [];}
        },

        contactsUrl: {
            type: String,
            default: 'contact',
        }

    },

    data() {
        return {
            dataItems: this.items,
            url: this.contactsUrl,
        };
    }

};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/organizations/OrganizationContactsComponent.vue